import { render, staticRenderFns } from "./SupportAccessBanner.vue?vue&type=template&id=78a40eea&scoped=true"
import script from "./SupportAccessBanner.vue?vue&type=script&lang=js"
export * from "./SupportAccessBanner.vue?vue&type=script&lang=js"
import style0 from "./SupportAccessBanner.vue?vue&type=style&index=0&id=78a40eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a40eea",
  null
  
)

export default component.exports